module.exports = __webpack_public_path__ + "img/logo-provino.fbe5ef08.png";